function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1126 1.22576L21.1126 5.11337C21.9621 5.52367 22.4996 6.36598 22.5001 7.28826V16.5508C22.4996 17.4728 21.9621 18.3151 21.1137 18.7249L13.1138 22.6124C12.4096 22.9549 11.5805 22.9549 10.8765 22.6125L2.87507 18.7242C2.02631 18.3085 1.49346 17.4611 1.50006 16.5408L1.50006 7.288C1.50056 6.36598 2.03799 5.52367 2.88645 5.11391L6.71817 3.25188C6.75541 3.22722 6.79582 3.20766 6.83814 3.19358L10.8876 1.22576C11.5884 0.887312 12.4118 0.887312 13.1126 1.22576ZM7.00506 4.19908L3.33256 5.98374C3.26532 6.01621 3.20134 6.05319 3.14093 6.0942L12.0001 10.3993L15.882 8.51286L7.00506 4.19908ZM17.0001 7.96955L8.12309 3.65577L11.3337 2.09559C11.7529 1.89314 12.2467 1.89306 12.667 2.09588L20.6665 5.9832C20.7341 6.01585 20.7984 6.05304 20.8591 6.09426L17.0001 7.96955ZM17.2288 8.945C17.2256 8.94659 17.2224 8.94816 17.2192 8.94969L12.5001 11.243V21.8123C12.5565 21.7926 12.6121 21.7696 12.6665 21.7432L20.6676 17.855C21.1773 17.6088 21.4998 17.1035 21.5001 16.5505L21.5001 7.28852C21.5 7.15395 21.4809 7.02222 21.4446 6.89635L17.2288 8.945ZM2.5555 6.89633L11.5001 11.243V21.8157C11.4402 21.7953 11.3813 21.7712 11.3238 21.7432L3.32367 17.8556C2.81579 17.6068 2.49608 17.0984 2.50005 16.5442L2.50006 7.28826C2.50013 7.15379 2.51926 7.02213 2.5555 6.89633Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2177_12278)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 23.3257,
  fill: "white"
}));

function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2177_12278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 22,
    height: 23
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.5a497671.svg";
export { ForwardRef as ReactComponent };